import { Nav, Navbar } from 'react-bootstrap';
// import { routes } from 'sitemap';
import { capitalize } from 'helpers/utils';
import NavbarVerticalMenu, {
  checkAnyPagePermission,
  NavItem
} from './NavbarVerticalMenu';
import {
  UilArrowFromRight,
  UilLeftArrowToLeft
} from '@iconscout/react-unicons';
import { useAppContext } from 'providers/AppProvider';
import classNames from 'classnames';
import Button from 'components/base/Button';
import NavbarTopNav from '../navbar-horizontal/NavbarTopNav';
import { useBreakpoints } from 'providers/BreakpointsProvider';
import NavbarVerticalCollapseProvider from './NavbarVerticalCollapseProvider';
import React, { useContext, useEffect, useState } from 'react';
import { AuthContext } from 'context/AuthContext';
import getRoute from 'sitemaps/getRoute';
// import { RouteItems } from 'sitemap';
import { useSelector } from 'react-redux';
import { useAuth } from 'hooks/auth/useAuth';
// import { store } from 'store';

export const allowedPage = (ability, routes) => {
  let count = 0;
  routes[1].pages.forEach(route => {
    // Check if actionName is an array
    const hasPermission = route.actionName.some(action =>
      ability.can(action.toLowerCase(), route.moduleName || '')
    );

    if (hasPermission) {
      count++;
    }
  });
  return count;
};

const NavbarVerical = () => {
  const { navbarChange } = useSelector(state => ({
    navbarChange: state.navbarUpdate.navbarChange
  }));
  const { abilities } = useAuth();

  const {
    config: {
      navbarPosition,
      openNavbarVertical,
      navbarVerticalAppearance,
      isNavbarVerticalCollapsed
    },
    setConfig
  } = useAppContext();
  const [routes, setRoutes] = useState([]);

  const { breakpoints } = useBreakpoints();
  const { user } = useContext(AuthContext);

  useEffect(() => {
    const fetchRoutes = async () => {
      try {
        const routeResult = user ? await getRoute(user) : [];
        setRoutes(routeResult);
      } catch (error) {
        console.error('Error fetching routes:', error);
      }
    };

    fetchRoutes();
  }, [user, navbarChange]);

  return (
    <NavbarVerticalCollapseProvider>
      <Navbar
        className={classNames('navbar-vertical', {
          'navbar-darker': navbarVerticalAppearance === 'darker'
        })}
        expand="lg"
        variant=""
      >
        <Navbar.Collapse id="navbarVerticalCollapse" in={openNavbarVertical}>
          <div className="navbar-vertical-content">
            <Nav className="flex-column" as="ul" id="navbarVerticalNav">
              {user !== null ? (
                <>
                  {routes.map((route, i) => (
                    <React.Fragment key={`${i}-sidebar-nav`}>
                      {route.label === 'Dashboard' &&
                        route.pages[0]?.moduleName === 'general_dashboard' && (
                          <>
                            {allowedPage(abilities, route.pages) === 0 && (
                              <>
                                <Nav.Item key={route.label}>
                                  {!route.labelDisabled && (
                                    <>
                                      <p className="navbar-vertical-label">
                                        {capitalize(route.label)}
                                      </p>
                                      <hr className="navbar-vertical-line" />
                                    </>
                                  )}
                                  <div key={route.pages[0].name}>
                                    <div className="nav-item-wrapper">
                                      <NavItem
                                        route={route.pages[0]}
                                        level={'1'}
                                      />
                                    </div>
                                  </div>
                                </Nav.Item>
                              </>
                            )}
                          </>
                        )}
                      {checkAnyPagePermission(abilities, route.pages) ? (
                        <Nav.Item key={route.label}>
                          {!route.labelDisabled && (
                            <>
                              <p className="navbar-vertical-label">
                                {capitalize(route.label)}
                              </p>
                              <hr className="navbar-vertical-line" />
                            </>
                          )}
                          {route.label === 'Dashboard' ? (
                            <>
                              <NavbarVerticalMenu
                                singleDashboard={
                                  allowedPage(abilities, route.pages) === 1
                                }
                                level={1}
                                routes={route.pages}
                              />
                            </>
                          ) : (
                            <NavbarVerticalMenu
                              level={1}
                              routes={route.pages}
                            />
                          )}
                        </Nav.Item>
                      ) : null}
                    </React.Fragment>
                  ))}
                </>
              ) : null}
            </Nav>

            {navbarPosition === 'combo' && breakpoints.down('lg') && (
              <div className="move-container">
                <div className="navbar-vertical-divider">
                  <hr className="navbar-vertical-hr" />
                </div>
                <NavbarTopNav />
              </div>
            )}
          </div>
        </Navbar.Collapse>
        <div className="navbar-vertical-footer">
          <Button
            className="navbar-vertical-toggle border-0 fw-semi-bold w-100 white-space-nowrap d-flex align-items-center"
            onClick={() => {
              setConfig({
                isNavbarVerticalCollapsed: !isNavbarVerticalCollapsed
              });
            }}
          >
            {isNavbarVerticalCollapsed ? (
              <UilArrowFromRight size={16} className="mb-1" />
            ) : (
              <>
                <UilLeftArrowToLeft size={16} className="mb-1" />
                <span className="ms-2">Collapsed View</span>
              </>
            )}
          </Button>
        </div>
      </Navbar>
    </NavbarVerticalCollapseProvider>
  );
};

export default NavbarVerical;
